import { render, staticRenderFns } from "./NetWorthChart.vue?vue&type=template&id=5f075187&"
import script from "./NetWorthChart.vue?vue&type=script&lang=js&"
export * from "./NetWorthChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports